/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Scope_Point_4Inputs */

const en_svc_agents_scope_point_4 = /** @type {(inputs: Svc_Agents_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduling, reminders and status updates`)
};

const lv_svc_agents_scope_point_4 = /** @type {(inputs: Svc_Agents_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plānošana, atgādinājumi un statusa ziņas`)
};

/**
* | output |
* | --- |
* | "Scheduling, reminders and status updates" |
*
* @param {Svc_Agents_Scope_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_scope_point_4 = /** @type {((inputs?: Svc_Agents_Scope_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Scope_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_scope_point_4(inputs)
	return en_svc_agents_scope_point_4(inputs)
});